import type {PaletteMode} from '@mui/material';

export const getHintTextColor = (mode: PaletteMode = 'light') => {
	// Increase for accessibilty
	return mode === 'light' ? 'rgba(0, 0, 0, 0.55)' : 'rgba(255, 255, 255, 0.48)';
};
